export default __webpack_public_path__ + "static/media/34M.a96d4bd4.jpeg";